import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-17142 — the attributes each summarized item had when
 * `sales_summary_invoice_group_day` last stored them: its category, product
 * group code, manufacturer, brand and family, and whether it exists, is
 * deleted or is active. Every 15 minutes the summary refresh compares these
 * with the items as they are now; for an item that changed it marks every
 * summarized day that sold it as waiting to be rebuilt, then records the new
 * attributes here. A rebuild only adds the items it has not seen, so an
 * item's change is always caught by the comparison, never written over.
 *
 * Not audited (`auditable: false`): derived bookkeeping of the summary.
 *
 * SM1 exposure: none. SM1 names no such table.
 */
@Entity('sales_summary_item_group', {}, { auditable: false })
@Index('sales_summary_item_group__fk_item__id', ['fkItemId'], { unique: true })
export class SalesSummaryItemGroupEntity extends BaseEntity {
	/** `item._id`. */
	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	/** 1 when the item row exists. */
	@Column({ type: 'boolean', name: 'hasItem', width: 1, default: () => "'0'" })
	public hasItem!: boolean;

	/** 1 when the item is soft-deleted. */
	@Column({ type: 'boolean', name: 'isItemDeleted', width: 1, default: () => "'0'" })
	public isItemDeleted!: boolean;

	@Column({ type: 'boolean', name: 'itemIsActive', width: 1, nullable: true })
	public itemIsActive!: boolean | null;

	@Column('varchar', { name: 'category', length: 64, nullable: true })
	public category!: string | null;

	@Column('varchar', { name: 'productGroupCode', length: 255, nullable: true })
	public productGroupCode!: string | null;

	@Column('varchar', { name: 'manufacturer', length: 255, nullable: true })
	public manufacturer!: string | null;

	@Column('varchar', { name: 'brandEquivalent', length: 255, nullable: true })
	public brandEquivalent!: string | null;

	@Column('varchar', { name: 'family', length: 255, nullable: true })
	public family!: string | null;
}
